export default "__VITE_ASSET__DhfJolNm__"